window.$ = window.jQuery = require('jquery');
require('./bootstrap');

window.site = {
  init: function() {
    this.blockcms();
    this.ajaxForms();
  },
  blockcms: function() {
        $('[data-anchor]').each(function(a,b) {
          var anchor = $(b).data('anchor');
          var link = $('<a>').attr('name',anchor);
          $(b).prepend(link);
        });
  },
  ajaxForms: function() {

    $('form[data-ajaxform]').find('.form-group[data-showwhen]').each(function(s,e) {
      var _showwhen = $(this).data('showwhen').split('=');
      var elm = _showwhen[0];
      var requirement = _showwhen[1];
      var $target = $('[name="' + elm + '"]');
      if($target) {

        var toggleTarget = $('.form-group[data-showwhen="'+$(this).data('showwhen')+'"]');
        if(requirement=='checked') {
          if($target.is(':checked')) {
            $(toggleTarget).removeClass('hidden');
          } else {
            $(toggleTarget).addClass('hidden');
          }
          $target.data('showwhentarget',toggleTarget);
          $target.unbind('change').bind('change',function() {
            $($(this).data('showwhentarget')).toggleClass('hidden');
          });
        }
        if(requirement=='unchecked') {
          if(!$target.is(':checked')) {
            $(toggleTarget).removeClass('hidden');
          } else {
            $(toggleTarget).addClass('hidden');
          }
          $target.data('showwhentarget',toggleTarget);
          $target.unbind('change').bind('change',function() {
            $($(this).data('showwhentarget')).toggleClass('hidden');
          });
        }
      }

    });

    $('form[data-ajaxform]').bind('submit',function(event) {
      event.preventDefault();
      var $form = $(this);
      var $response = $('#'+$(this).attr('id')+'-response');

      $form.find('.form-group').addClass('hidden');
      $form.find('.hide-after-submit').addClass('hidden');
      $form.parents('.modal-body').find('.hide-after-submit').addClass('hidden');
      $form.find('.busy').removeClass('hidden');
      var form_data = new FormData($(this)[0]);
	var recaptchasitekey = "6LfQKt0ZAAAAAJ-XgDp0HzpGXQDIi-5dQbLJvBFf";
      if($form.data('recaptcha')==true) {
        grecaptcha.ready(function() {
          grecaptcha.execute(recaptchasitekey, {action: 'submit'}).then(function(token) {
              // Add your logic to submit to your backend server here.
              form_data.append('gRecaptchaResponse',token);
              $.ajax({
                type:'POST',
                url:$form.attr('action'),
                processData: false,
                contentType: false,
                cache: false,
                data : form_data,
                success: function(response){
      
                  $form.find('h3.tussenkop').html("Succesvol verzonden").removeClass('hidden');
                  $form.find('.busy').addClass('hidden');
                  $form.find('.hide-after-submit').addClass('hidden');
                  $response.removeClass('hidden');
                }
              });
          });
        });

      } else {
        $.ajax({
          type:'POST',
          url:$(this).attr('action'),
          processData: false,
          contentType: false,
          cache: false,
          data : form_data,
          success: function(response){

            $form.find('h3.tussenkop').html("Succesvol verzonden").removeClass('hidden');
            $form.find('.busy').addClass('hidden');
            $form.find('.hide-after-submit').addClass('hidden');
            $response.removeClass('hidden');
          }
        });
      }

    


      return false;
    }).removeAttr('data-ajaxform');

  }
}

$(function() {
  window.site.init();
})


$(document).ready(function () {
// Table swipeable
  $('table').wrap('<div class="table-wrapper"></div>');
  $('<div class="swipehint touch">Swipe naar links</div>').insertBefore('.table-wrapper');
  $('<div class="swipehint scroll">Scroll naar links</div>').insertBefore('.table-wrapper');

  // Responsive 16:9 video iframe embed
  $('iframe').wrap('<div class="embed-wrapper"></div>');

  //Make whole parent-card clickable by finding a certain a-link
  $('.js-blocklink').unbind('click').bind('click', function () {
    window.location = $(this).find('a.block-link').first().attr('href');
  });

});



// WEBPACK FOOTER //
// ./resources/js/site.js